// src/pages/cities/Cities.jsx
import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import CitiesTable from "../../components/cities/CitiesTable";

const Cities = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <CitiesTable />
        </WrapperSection>
    );
};

export default Cities;
